import React from "react";
import { useSearchParams } from "react-router-dom";
import LoginPage from "./_pg_login.js";
import _44_user_register from "./_44_user_register.js";
import TodayPassResetPage from "./_pg_pass_reset.js";

const AuthScreen = (props) => {
    const [params] = useSearchParams();
    const screen = (params.get("screen") || "login").toLowerCase();

    if (screen === "register") {
        return (
            <_44_user_register
                {...props}
                screen="_44_user_register"
            />
        );
    }

    if (screen === "password-reset") {
        return (
            <TodayPassResetPage
                {...props}
                screen="password_reset"
            />
        );
    }

    // default: login
    return <LoginPage {...props} />;
};

export default AuthScreen;